module.exports = __webpack_public_path__ + "media/brands/john-deere-ca1a8830.png";